import {Component, ComponentOptions} from "@mecatran-components/component";
import {DomUtils, SystemUtils} from "@mecatran/utilities/src/index.web.mjs";
import {Selectable, DataProvider} from "./interfaces/index.mjs";


export class ListItem extends SystemUtils.mix(Component).include(Selectable,DataProvider){  // mix(Component, Selectable, DataProvider){
    constructor(...params){
        super(...params);
        var _data;

        Object.defineProperty(this,'data',{
            set : function(d){ _data = d },
            get : function(){ return _data }
        })

        Object.defineProperty(this,'isSelectable',{
            value : function(){ return true }
        });

        this.initListItem();
    }

    // ==========
    // private 
    // ----------
    initListItem(){
        if (this.isSelectable()) this.initSelectable();
    }

    initSelectable(){
        var domNode = this.getDomManager().getDomNode();
        DomUtils.addClassList(['selectable'],domNode)
    }

    getContext(){  // protected
        var data = this.getData();
        return this.createContext(data); 
    }

    // ===========
    // overloadable
    // -----------

    

    createContext(data){
        return data;
    }

    createContainerNode(){
        var div = document.createElement('div');
        div.setAttribute('class','item');
        return div;
    }

    build(){
        var context = this.getContext();
        this.getContentOptions().setContext(context);
        super.build();
        return; 
    }

 

    // ===========
    // public
    // -----------
    getData(){ return this.data }

    setData(d){ this.data = d  }
}






